import { fromJS } from 'immutable';
import { isToday, subDays, isPast } from 'date-fns';
import accounting from 'accounting';

export function getUrlParams(params) {
  const v = window.location.search.match(new RegExp(`(?:[?&]${params}=)([^&]+)`));
  return v ? v[1] : undefined;
}

export function getParamsUrlString(url, params) {
  if (url) {
    const v = url.match(new RegExp(`(?:[?&]${params}=)([^&]+)`));
    return v ? v[1] : undefined;
  }
  return undefined;
}

export function getUrlArray() {
  return window.location.pathname.split('/');
}

export function formatFullDate(dates, Minus = false) {
  const time = new Date(dates);
  let month = time.getMonth() + 1;
  let date = time.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (date < 10) {
    date = `0${date}`;
  }
  if (Minus) {
    return `${time.getFullYear()}-${month}-${date}`;
  }
  return `${time.getFullYear()}/${month}/${date}`;
}

function validateExists(id, mainItems) {
  const items = mainItems || [];
  let found = false;
  // Kiểm tra có bị trùng item không
  items.forEach(item => {
    if (parseInt(item) === parseInt(id)) {
      found = true;
    }
  });
  return found;
}

export function removeArray(array, sl) {
  const newArray = [];
  let i = array.length - 1;
  while (i > 0) {
    newArray.unshift(array[i]);
    if (i - sl <= 0) {
      newArray.unshift(array[0]);
    }
    i -= sl;
  }
  return newArray;
}

export function customFieldProduct(items, mainItems) {
  const mainItemToJs = mainItems ? mainItems.toJS() : [];
  for (let i = 0; i < items.length; i++) {
    // const defaultImage = item.images[0] ? item.images[0].originalSrc : '';
    const id = items[i].id;
    // const variants = item.variants;
    const newId = id.substr(id.lastIndexOf('/') + 1);
    const isExists = validateExists(newId, mainItems);
    if (!isExists) {
      mainItemToJs.unshift(parseInt(newId));
    }
  }
  return mainItemToJs;
}

export function customFieldCollection(items, mainItems) {
  const mainItemToJs = mainItems ? mainItems.toJS() : [];
  items.forEach(async item => {
    const id = item.id;
    const newId = id.substr(id.lastIndexOf('/') + 1);
    const isExists = validateExists(newId, mainItems);
    if (!isExists) {
      mainItemToJs.unshift(parseInt(newId));
    }
  });
  return mainItemToJs;
}
// log

export function timeAgo(date) {
  const dates = new Date(date).getTime();
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = day * 365;

  const suffix = ' ago';

  const elapsed = Math.floor((Date.now() - dates) / 1000);

  if (elapsed < minute) {
    return 'just now';
  }

  // get an array in the form of [number, string]
  const a = (elapsed < hour && [Math.floor(elapsed / minute), 'minute']) ||
    (elapsed < day && [Math.floor(elapsed / hour), 'hour']) ||
    (elapsed < month && [Math.floor(elapsed / day), 'day']) ||
    (elapsed < year && [Math.floor(elapsed / month), 'month']) || [Math.floor(elapsed / year), 'year'];

  // pluralise and append suffix
  return `${a[0]} ${a[1]}${a[0] === 1 ? '' : 's'} ${suffix}`;
}

export function getDateBefore(date, number) {
  const dates = new Date(date).getTime();
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;

  const dateBefore = new Date(dates - number * day * 1000);

  let timeStart;
  let timeEnd;

  if (dateBefore.getMonth() + 1 < 10) {
    timeStart = `${dateBefore.getFullYear()}-0${dateBefore.getMonth() + 1}-${
      dateBefore.getDate() < 10 ? '0' : ''
    }${dateBefore.getDate()}`;
  } else {
    timeStart = `${dateBefore.getFullYear()}-${dateBefore.getMonth() + 1}-${
      dateBefore.getDate() < 10 ? '0' : ''
    }${dateBefore.getDate()}`;
  }

  if (date.getMonth() + 1 < 10) {
    timeEnd = `${date.getFullYear()}-0${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  } else {
    timeEnd = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  }

  const data = {
    now: `${timeEnd}`,
    before: `${timeStart}`
  };

  return data;
}

export function formatDate(dates) {
  const newDate = dates || [];
  const data = newDate.map(date => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(new Date(date));
  });

  return data;
}

export function formatMonth(dates = []) {
  const newDate = dates || [];
  const data = newDate.map(date => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short'
    }).format(new Date(date));
  });

  return data;
}

export function getImageResize(url, size = '') {
  const pos = url.lastIndexOf('.');
  const length = url.length;
  const firstString = url.substr(0, pos);
  const lastString = url.substr(pos, length - pos);
  const data = firstString + size + lastString;

  return data;
}

export function fixDataQuickView(value) {
  if (value === 'white' || value === 'black') {
    return fromJS([value]);
  }
  return value;
}

export function convertProductListToIdList(productList) {
  // Check first element if is an object then handle convert to array id string
  const newArray = [];
  if (productList.length > 0 && productList[0].id) {
    for (let i = 0; i < productList.length; i++) {
      newArray.push(parseInt(productList[i].id));
    }
  }
  if (newArray.length > 0) return newArray;
  return productList;
}

/**
 * Limit loop using requestAnimationFrame if timeOut have param, interval will by timeOut config
 * @param fn
 * @param fps : number = 30 fps
 * @param timeOut
 */
export function limitLoop(fn, fps = 30, timeOut = null) {
  // Use var then = Date.now(); if you
  // don't care about targeting < IE9
  let then = new Date().getTime();
  const interval = timeOut || 1000 / fps;

  return (function loop() {
    window.requestAnimationFrame(loop);
    // again, Date.now() if it's available
    const now = new Date().getTime();
    const delta = now - then;
    if (delta > interval) {
      // Update time
      // now - (delta % interval) is an improvement over just
      // using then = now, which can end up lowering overall fps
      then = now - (delta % interval);
      // call the fn
      fn();
    }
  })(0);
}

export function getCheckEndDate(startDate) {
  let checkEndDate = new Date();
  if (startDate === '') {
    checkEndDate = subDays(checkEndDate.getDate(), 1);
  } else {
    const st = new Date(startDate);
    checkEndDate = subDays(st, 1);
    // Kiểm tra thời gian cho phép chọn có nhỏ hơn ngày hiện tại hay không, nếu nhỏ hơn ngày hiện tại thì sẽ lấy ngày hiện tại làm mốc thời gian
    if (isPast(checkEndDate)) {
      checkEndDate = subDays(new Date(), 1);
    }
  }
  return checkEndDate;
}

export const formatMoney = (price, moneyFormat) => {
  const withCurrency = moneyFormat || '{{amount}}';
  let money = price;
  if (withCurrency.indexOf('{{amount}}') >= 0) {
    money = accounting.formatMoney(money, '', 2, ',', '.');
    money = withCurrency.replace('{{amount}}', money);
  } else if (withCurrency.indexOf('{{amount_with_comma_separator}}') >= 0) {
    money = accounting.formatMoney(money, '', 2, '.', ',');
    money = withCurrency.replace('{{amount_with_comma_separator}}', money);
  } else if (withCurrency.indexOf('{{amount_no_decimals_with_comma_separator}}') >= 0) {
    money = accounting.formatMoney(money, '', 0, '.', ',');
    money = withCurrency.replace('{{amount_no_decimals_with_comma_separator}}', money);
  } else if (withCurrency.indexOf('{{amount_no_decimals}}') >= 0) {
    money = accounting.formatMoney(money, '', 0, ',', '.');
    money = withCurrency.replace('{{amount_no_decimals}}', money);
  } else if (withCurrency.indexOf('{{amount_with_apostrophe_separator}}') >= 0) {
    money = accounting.formatMoney(money, '', 2, "'", '.');
    money = withCurrency.replace('{{amount_with_apostrophe_separator}}', money);
  } else {
    money = accounting.formatMoney(money, '', 2, ',', '.');
  }
  return money;
};

export const minutesSelect = [
  { label: '00', value: 0 },
  { label: '01', value: 1 },
  { label: '02', value: 2 },
  { label: '03', value: 3 },
  { label: '04', value: 4 },
  { label: '05', value: 5 },
  { label: '06', value: 6 },
  { label: '07', value: 7 },
  { label: '08', value: 8 },
  { label: '09', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
  { label: '32', value: 32 },
  { label: '33', value: 33 },
  { label: '34', value: 34 },
  { label: '35', value: 35 },
  { label: '36', value: 36 },
  { label: '37', value: 37 },
  { label: '38', value: 38 },
  { label: '39', value: 39 },
  { label: '40', value: 40 },
  { label: '41', value: 41 },
  { label: '42', value: 42 },
  { label: '43', value: 43 },
  { label: '44', value: 44 },
  { label: '45', value: 45 },
  { label: '46', value: 46 },
  { label: '47', value: 47 },
  { label: '48', value: 48 },
  { label: '49', value: 49 },
  { label: '50', value: 50 },
  { label: '51', value: 51 },
  { label: '52', value: 52 },
  { label: '53', value: 53 },
  { label: '54', value: 54 },
  { label: '55', value: 55 },
  { label: '56', value: 56 },
  { label: '57', value: 57 },
  { label: '58', value: 58 },
  { label: '59', value: 59 }
];

export const hoursSelect = [
  { label: '00', value: 0 },
  { label: '01', value: 1 },
  { label: '02', value: 2 },
  { label: '03', value: 3 },
  { label: '04', value: 4 },
  { label: '05', value: 5 },
  { label: '06', value: 6 },
  { label: '07', value: 7 },
  { label: '08', value: 8 },
  { label: '09', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 }
];

function validHourFormat(i) {
  if (i < 10) {
    return `0${i}`;
  }
  return `${i}`;
}

export function getOptionHour(date) {
  const currentHour = new Date().getHours();
  const isTodayResult = isToday(date);
  const optionsHour = [];
  let hourValue = '';
  for (let i = 0; i < 24; i++) {
    // Kiểm tra nếu là ngày hôm nay sẽ thực hiện disabled các giờ nhỏ hơn giờ hiện tại
    if (isTodayResult) {
      // Trả về định dạng giờ
      hourValue = validHourFormat(i);

      if (currentHour > i) {
        optionsHour.push({
          label: hourValue,
          value: hourValue,
          disabled: true
        });
      } else {
        optionsHour.push({ label: hourValue, value: hourValue });
      }
    } else {
      // Trả về định dạng giờ
      hourValue = validHourFormat(i);

      // Nếu không phải ngày hôm nay thì sẽ chọn phép chọn tất cả các khung giờ
      optionsHour.push({ label: hourValue, value: hourValue });
    }
  }
  return optionsHour;
}
